import React from 'react';
import { HeaderFilterTable } from '@/components/common';
import { Options } from '@/components/ui/combobox';
import { useApplyFilterMultiple } from '@/hooks/filters/useApplyFilterMultiple';

interface Props {
	disabled?: boolean;
}

export const ClientStatus: React.FC<Props> = ({ disabled }) => {
	const { selected, hasFilter, handleClearAll, handleSelectFilters } =
		useApplyFilterMultiple({ filterKey: 'client_status' });

	const data: Options[] = [
		{
			label: 'All Received',
			value: 'All Received',
		},
		{
			label: 'Missing',
			value: 'Missing',
		},
	];

	return (
		<HeaderFilterTable
			title="Client Status"
			searchTitle="Client Status"
			type="multiple"
			values={selected}
			filterOptions={data}
			handleClearAll={handleClearAll}
			handleSelectFilters={handleSelectFilters}
			hasFilter={hasFilter('client_status')}
			classNamePopoverContent="lg:w-[302px]"
			buttonContentDefault={false}
			disabled={disabled}
		/>
	);
};
